import { IResponse } from '@zmedia/bm-soccer-ui/interface';
import { getWithPath } from '@zmedia/bm-soccer-ui/utils/http';

const API_PATH = {
    GET_OVERVIEW: '/team/get/overview',
    GET_MATCHES: '/team/get/matches',
    GET_SQUAD: '/team/get/squad',

};

export const TeamService = {
    getOverview: (id: string): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_OVERVIEW, { id });
    },
    getMatches: (id: string): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_MATCHES, { id });
    },
    getSquad: (params: any): Promise<IResponse<any>> => {
        return getWithPath(API_PATH.GET_SQUAD, params);
    },
};

export default TeamService;
